import { keycloakUtils } from "itsf-ui-common";
import { IDataLayerPrequalEvent } from "./prequal";
import { IDataLayerAddToCartEvent } from "./addToCart";
import { IDataLayerViewCartEvent } from "./viewCart";
import { IDataLayerPurchaseEvent } from "./purchase";
import { IDataLayerRemoveCartEvent } from "./removeCart";

export enum EDataLayerEventType {
    ADD_TO_CART = "add_to_cart",
    REMOVE_CART = "remove_cart",
    PREQUAL = "prequal",
    PURCHASE = "purchase",
    VIEW_CART = "view_cart",
}

export enum EDataLayerCustomerJourneyType {
    CONNECTED = "CROSS_SELL",
    DISCONNECTED = "Acquisition",
}

interface IDataLayerEvent {
    customerJourneyType: EDataLayerCustomerJourneyType;
    pageUrl: string;
}

type TDataLayerDetailedEvent =
    | IDataLayerPrequalEvent
    | IDataLayerAddToCartEvent
    | IDataLayerRemoveCartEvent
    | IDataLayerViewCartEvent
    | IDataLayerPurchaseEvent;
export type TDataLayerEvent = TDataLayerDetailedEvent & IDataLayerEvent;

export const sendEvent = (eventPayload: TDataLayerDetailedEvent) => {
    const event: TDataLayerEvent = {
        customerJourneyType: keycloakUtils.isAuthenticated()
            ? EDataLayerCustomerJourneyType.CONNECTED
            : EDataLayerCustomerJourneyType.DISCONNECTED,
        pageUrl: window.location.href,
        ...eventPayload,
    };
    global.dataLayer.push(event);
};
